import React from 'react';
import { Modal } from 'antd';

interface HistoryDeleteModalProps {
  visible: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void> | void;
}

const HistoryDeleteModal: React.FC<HistoryDeleteModalProps> = ({ visible, loading = false, onCancel, onConfirm }) => {
  return (
    <Modal title="删除会话" open={visible} okText="删除" cancelText="取消" okButtonProps={{ danger: true }} confirmLoading={loading} onOk={onConfirm} onCancel={onCancel} destroyOnClose>
      <div className="session-history-menu-footer-delete-text">删除后该会话将被清除且不可恢复，请谨慎操作。</div>
    </Modal>
  );
};

export default HistoryDeleteModal;
